import { createContext, useState, useEffect } from "react";
// import useLocalStorage from "../hooks/useLocalStorage";
import { AuthContextType } from "../types/contexts/AuthContext";
import { refreshTokens } from "../services/auth.service";
import useLocalStorage from "../hooks/useLocalStorage";

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  isLoading: false,
  updateAuthentication: () => {},
  updateLoading: () => {},
  logout: () => {},
});

const AuthProvider: any = ({ children }: any) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [refreshToken, setRefreshToken] = useLocalStorage("refresh-token");
  const [isLoading, setIsLoading] = useState<boolean>(true); // Set initial value to true

  const updateAuthentication = (authenticated: any) => {
    setIsAuthenticated(authenticated);
    setIsLoading(false);
  };

  const logout = () => {
    localStorage.clear();
    setIsAuthenticated(false);
    setIsLoading(false);
  };

  const updateLoading = (isLoading: boolean) => {
    setIsLoading(isLoading);
  };

  useEffect(() => {
    if (refreshToken) {
      refreshTokens({
        refreshToken: refreshToken,
      })
        .then((response) => {
          setRefreshToken(response.data.tokens.refresh.token);
          setIsAuthenticated(true);
          setIsLoading(false);
        })
        .catch(() => {
          logout();
        });
    } else {
      setIsLoading(false);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, isLoading, updateAuthentication, updateLoading, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
